/* eslint-disable dot-notation */
import React from 'react';
import { getLocal } from 'mt-react-common/utils/formatter';
import ApiDocsLoadableWrapped from '../ApiDocsLoadableWrapped';

const PublicApiDoc = () => {
  const locale = getLocal();
  return (
    <ApiDocsLoadableWrapped
      jsonUrl={`${process.env['API_URL']}/kernel/main/doc?locale=${locale}`}
    />
  );
};

export default PublicApiDoc;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ApiDoc/PublicApiDoc/index.js